export default "__VITE_PUBLIC_ASSET__39e450f6__"